import { Checkbox } from '../Checkbox';
import { StyledQmarkCheckboxes } from './style';
import { useIntl } from 'react-intl';
import React, { useEffect, useMemo, useState } from 'react';
import { DeliveryFilterOptions } from 'types/FilterOptions';
import { Icon } from 'ui';

interface Props {
  delivery: DeliveryFilterOptions[] | undefined;
}

export const DeliveriesCheckboxes = ({ delivery }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isEmpty, setIsEmpty] = useState<boolean>();
  const intl = useIntl();

  const handleOnClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const isEmpty = !delivery || delivery.length === 0;

    if (isOpen) {
      setIsOpen(!isEmpty);
    }

    setIsEmpty(isEmpty);
  }, [delivery]);

  const translatedDelivery = useMemo(() => {
    return delivery?.map((deliveryItem) => ({
      ...deliveryItem,
      label: intl.formatMessage({ id: `delivery.${deliveryItem.label}` }),
    }));
  }, [delivery, intl]);

  return (
    <StyledQmarkCheckboxes>
      <div
        className="qmark-filter-title"
        onClick={!isEmpty ? handleOnClick : undefined}
      >
        <div>{intl.formatMessage({ id: 'form.delivery_filter_title' })}</div>
        <div className={`icon ${!isOpen ? 'collapsed' : ''}`}>
          <Icon name="arrow" />
        </div>
      </div>
      {isOpen && (
        <Checkbox
          name="delivery"
          options={translatedDelivery}
          filterView={true}
        />
      )}
    </StyledQmarkCheckboxes>
  );
};
